export default __webpack_public_path__ + "assets/images/mysql.99d2df3.png";